import React, { useState, useEffect, useRef, useCallback } from 'react';
import './ServerView.css';
import CallView from '../Call/CallView';
import { channelsService } from '../../services/channels';
import { sitesService } from '../../services/sites';
import { chatHub } from '../../services/signalr';
import { filesService } from '../../services/files';
import { authService } from '../../services/authService';
import InfiniteScroll from 'react-infinite-scroll-component';
import UserSettings from './UserSettings';
import PersonalData from './PersonalData';
import MessageReactions from '../MessageReactions/MessageReactions';
import { favoritesService } from '../../services/favorites';
import ImageGallery from '../Gallery/ImageGallery'; 
import MarkdownRenderer from '../Markdown/MarkdownRenderer';
import TasksBoard from '../Project/Tasks/TasksBoard';
import CollectionSetBoard from '../Collection/CollectionSetBoard';
import CollectionBoard from '../Collection/CollectionBoard';
import { collectionService } from '../../services/collectionService';
import { playNotificationSound, unlockAudio } from '../../utils/notificationSound';
import { SITE_SHORTCUTS } from '../../config/shortcuts';

const ServerView = ({ user, onLogout }) => {
  const [isInCall, setIsInCall] = useState(false);
  const [activeChannel, setActiveChannel] = useState(null);
  const [messages, setMessages] = useState([]);
  const [inputMessage, setInputMessage] = useState('');
  const [sites, setSites] = useState([]);
  const [activeSite, setActiveSite] = useState(null);
  const [channels, setChannels] = useState([]);
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasMoreMessages, setHasMoreMessages] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  
  // Состояния для модального окна создания сайта
  const [isCreateSiteModalOpen, setIsCreateSiteModalOpen] = useState(false);
  const [newSiteName, setNewSiteName] = useState('');
  const [newSiteDescription, setNewSiteDescription] = useState('');
  const [newSiteIcon, setNewSiteIcon] = useState(null);
  const [isCreatingSite, setIsCreatingSite] = useState(false);
  const [siteMembers, setSiteMembers] = useState([]);
  const [selectedMemberIds, setSelectedMemberIds] = useState([]);
  const [allUsers, setAllUsers] = useState([]);

  const [contextMenu, setContextMenu] = useState(null);
  const [editingSite, setEditingSite] = useState(null);
  const [editSiteName, setEditSiteName] = useState('');
  const [editSiteDescription, setEditSiteDescription] = useState('');
  const [editSiteIcon, setEditSiteIcon] = useState(null);
  const [selectedEditMembers, setSelectedEditMembers] = useState([]);
  const [isUpdatingSite, setIsUpdatingSite] = useState(false);

  // Состояния для управления каналами
  const [isChannelModalOpen, setIsChannelModalOpen] = useState(false);
  const [editingChannel, setEditingChannel] = useState(null);
  const [channelName, setChannelName] = useState('');
  const [channelTopic, setChannelTopic] = useState('');
  const [channelPosition, setChannelPosition] = useState(0);
  const [isCreatingChannel, setIsCreatingChannel] = useState(false);
  const [channelContextMenu, setChannelContextMenu] = useState(null);

  const [shouldScrollToBottom, setShouldScrollToBottom] = useState(true);

  const [channelParticipants, setChannelParticipants] = useState({});

  const [viewMode, setViewMode] = useState('channels'); // 'channels' или 'settings'
  const [settingsMode, setSettingsMode] = useState('main'); // 'main', 'personal', 'private'

  //Редактирование сообщений
  const [contextMenuEditMessage, setContextMenuEditMessage] = useState(null);
  const [editingMessageId, setEditingMessageId] = useState(null);
  const [editMessageContent, setEditMessageContent] = useState('');

  //Оставлять реакции
  const [showReactionPicker, setShowReactionPicker] = useState(null); // messageId or null
  const [reactionPickerPosition, setReactionPickerPosition] = useState({ x: 0, y: 0 });
  //Избранное
  const [savedMessageIds, setSavedMessageIds] = useState([]);
  //SignalR 
  const [isSignalRConnected, setIsSignalRConnected] = useState(false);

  // Сообщение, на которое отвечаем
  const [replyToMessage, setReplyToMessage] = useState(null); 

  //Поиск
  const [searchQuery, setSearchQuery] = useState('');
  const [isSearchMode, setIsSearchMode] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);

  //Отмечать пользователей 
  const [mentionSuggestions, setMentionSuggestions] = useState([]);
  const [showMentions, setShowMentions] = useState(false);
  const [mentionSearch, setMentionSearch] = useState('');
  const messageInputRef = useRef(null);
  const [allChannelMembers, setAllChannelMembers] = useState({});

  //Галерея
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [galleryImages, setGalleryImages] = useState([]);
  const [isLoadingGallery, setIsLoadingGallery] = useState(false);
  //Доска задач
  const [channelType, setChannelType] = useState('text');
  const [areas, setAreas] = useState(['Идеи']);
  //Коллекции
  const [collectionSets, setCollectionSets] = useState([]);
  const [collectionSetId, setCollectionSetId] = useState('');
  //Юзер аечатает
  const [typingUser, setTypingUser] = useState(null);
  const lastTypingTime = useRef(0);
  const typingTimeoutRef = useRef(null);
  //Загрузка файлов
  const [uploadingMessages, setUploadingMessages] = useState([]);
  const MAX_FILE_SIZE = 1073741824; // 1 ГБ в байтах

  //Мигание не прочитанных сообщений
  const [unreadCounts, setUnreadCounts] = useState({}); // { channelId: count }
  const [siteUnreadCounts, setSiteUnreadCounts] = useState({}); // { siteId: count }
  const activeSiteRef = useRef(null);
  const [directMessageUnread, setDirectMessageUnread] = useState({});


  const canWrite = activeChannel?.canWrite === true ?? true;
  const canCall = activeChannel?.canCall === true ?? true;
  ///Остальное
  const messagesEndRef = useRef(null);
  const fileInputRef = useRef(null);
  const linkify = (text) => {
    if (!text) return text;
    
    // Regex для поиска URL
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(urlRegex, (url) => 
      `<a href="${url}" target="_blank" rel="noopener noreferrer" class="message-link">${url}</a>`
    );
  };

  const [chatScrollPosition, setChatScrollPosition] = useState(0);

  const activeChannelRef = useRef(null);

  // Следим за изменением activeChannel и обновляем ref
  useEffect(() => {
    if (activeChannel) {
      activeChannelRef.current = activeChannel;
    }
  }, [activeChannel]);

  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (url) => {
    setSelectedImage(url);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };
  //Смайлики
  const emojify = (text) => {
    if (!text) return text;
    
    const emojiMap = {
      ':)': '😊',
      ':(' : '😔',
      ';)': '😉',
      ':D': '😃',
      ':P': '😛',
      ':O': '😮',
      ':|': '😐',
      ':/': '😕',
      ':\')': '😂',
      'XD': '😆',
      '^_^': '😊',
      '<3': '❤️',
      ':*': '😘',
      '>.<': '😖',
      ':3': '😊',
      ':3': '😺'
    };
    
    // Заменяем все смайлики
    let result = text;
    for (const [key, value] of Object.entries(emojiMap)) {
      result = result.replace(new RegExp(RegExp.escape(key), 'g'), value);
    }
    
    return result;
  };
  
  // Для экранирования спецсимволов в Regex
  RegExp.escape = function(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  };
  // Загрузка сайтов при монтировании
useEffect(() => {
  loadUserSites();
  
  

  // Подключаемся к SignalR
  const connectToSignalR = async () => {
    const token = localStorage.getItem('videochat_token');
    //console.log('token'+ token);
    if (token) {
      //console.log('Начинаем подключение к SignalR...');
      try {
        await chatHub.connect(token);
        //console.log('SignalR подключен успешно!');
        setIsSignalRConnected(true); // ✅ Устанавливаем флаг
        // Настраиваем обработчики
        chatHub.on('onMessage', (message) => {
          setMessages(prev => [...prev, message]);
          setShouldScrollToBottom(true); // Новое сообщение — скролл вниз

          if (message.authorId !== user.id) {
            playNotificationSoundP();
            chatHub.acknowledgeMessageDelivery(message.id);
          }

          if (activeChannelRef.current?.id === message.channelId) {
            chatHub.markChannelAsRead(message.channelId);
          }
        });
        
        chatHub.on('onMessageEdited', (message) => {
          setMessages(prev => prev.map(m => 
            m.id === message.id ? message : m
          ));
        });
        
        chatHub.on('onMessageDeleted', (messageId) => {
          setMessages(prev => prev.filter(m => m.id !== messageId));
        });
        
        chatHub.on('onUserTyping', (username) => {
          
          if (username !== user.username) {
            setTypingUser(username);
            lastTypingTime.current = Date.now(); // Запоминаем время последнего события
    
            // Если таймер уже есть — сбрасываем его
            if (typingTimeoutRef.current) {
                clearTimeout(typingTimeoutRef.current);
            }
    
            // Запускаем новый таймер (сброс через 3 секунды после последнего события)
            typingTimeoutRef.current = setTimeout(() => {
                setTypingUser(null);
                typingTimeoutRef.current = null;
            }, 3000);
          }
        
        });
        
        chatHub.on('onReceiveMessage', (message) => {
          setMessages(prev => [...prev, message]);
          setShouldScrollToBottom(true);
          scrollToBottom();
        
          // 🟢 Сразу подтверждаем доставку (только если не автор)
          if (message.authorId !== user.id) {
            chatHub.acknowledgeMessageDelivery(message.id, activeChannel.id);
          }
        });

        chatHub.on('onMessageReadBy', (message) => {
          //setMessages(prev => [...prev, message]);
           setMessages(prev => prev.map(msg => {
             if (msg.id === message.id) {
               
               return message;
             }
             return msg;
           }));
        });
        
        // Подключение пользователя к каналу
        chatHub.on('onUserJoinedChannel', (userId, username, avatarUrl, status, channelId, channelName) => {
          console.log(`🟢 ${username} подключился к каналу ${channelName} (${channelId})`);
          
          setChannelParticipants(prev => {
              const currentMembers = prev[channelId] || [];
              if (currentMembers.some(m => m.id === userId)) return prev;

              return {
                  ...prev,
                  [channelId]: [...currentMembers, { id: userId, username, avatarUrl, status }]
              };
          });
        });

        // Отключение пользователя от канала
        chatHub.on('onUserLeftChannel', (userId, channelId) => {
          console.log(`🔴 Пользователь ${userId} покинул канал ${channelId}`);

          setChannelParticipants(prev => ({
              ...prev,
              [channelId]: (prev[channelId] || []).filter(m => m.id !== userId)
          }));
        });

        chatHub.on('onUserLeft', (userId, channelId) => {
          //console.log(`🔴 UserLeft: ${userId}`);
        });
        chatHub.onReconnected = (connectionId) => {
          if (activeChannelRef.current) {
            chatHub.joinChannel(activeChannelRef.current.id);
          }
          
        };
        chatHub.on('onUnreadMessage', (channelId, siteId, message) => {
          // Если это текущий канал — не увеличиваем
          if (activeChannelRef.current?.id === channelId) return;
          // Если это наше сообщение — не увеличиваем
          if (message.authorId === user.id) return;
      
          // 1. Счётчик канала
          setUnreadCounts(prev => ({
              ...prev,
              [channelId]: (prev[channelId] || 0) + 1
          }));
      
          // 2. Счётчик сайта — используем siteId из события
          if (siteId) {
              setSiteUnreadCounts(prev => ({
                  ...prev,
                  [siteId]: (prev[siteId] || 0) + 1
              }));
          }
      
          playNotificationSound();
        });

        chatHub.on('onUnreadDirectMessage', (channelId, senderId, senderName, senderAvatar, message) => {
          // Если это наш текущий канал — не увеличиваем
          if (activeChannelRef.current?.id === channelId) return;
          if (message.authorId === user.id) return;
      
          setDirectMessageUnread(prev => ({
              ...prev,
              [senderId]: (prev[senderId] || 0) + 1
          }));
      
          playNotificationSound();
        });
      } catch (error) {
        console.error('Ошибка подключения к SignalR:', error);
        setIsSignalRConnected(false);
      }
    }
  };
  
  connectToSignalR();
  
  return () => {
    chatHub.disconnect();
  };
}, []);

  // Загрузка каналов при выборе сайта
  useEffect(() => {
    if (activeSite) {
      loadSiteChannels(activeSite.id);

      activeSiteRef.current = activeSite;
    }
  }, [activeSite]);

  // Загрузка сообщений при выборе канала
  useEffect(() => {
    if (activeChannel && isSignalRConnected) {
      //console.log('Присоединение к каналу:', activeChannel.id);
      setShouldScrollToBottom(true);
      loadMessages(activeChannel.id);
      
      handleChannelChange(activeChannel);
      // Присоединяемся к каналу в SignalR
      chatHub.joinChannel(activeChannel.id);

      // Сбрасываем непрочитанные для этого канала
      setUnreadCounts(prev => {
        const updated = { ...prev };
        delete updated[activeChannel.id];
        return updated;
      });

      // Если это личный канал — сбрасываем счётчик DM
      if (activeChannel.otherUserId) {
        setDirectMessageUnread(prev => {
          const updated = { ...prev };
          delete updated[activeChannel.otherUserId];
          return updated;
        });
      }

      // Уменьшаем счётчик сайта
      if (activeChannel.siteId) {
        const channelUnread = unreadCounts[activeChannel.id] || 0;
        setSiteUnreadCounts(prev => {
            const updated = { ...prev };
            const newCount = Math.max(0, (updated[activeChannel.siteId] || 0) - channelUnread);
            if (newCount === 0) delete updated[activeChannel.siteId];
            else updated[activeChannel.siteId] = newCount;
            return updated;
        });
    }

      // Отправляем на бэкенд
      chatHub.markChannelAsRead(activeChannel.id);

      return () => {
        chatHub.leaveChannel(activeChannel.id);
        chatHub.markChannelAsRead(activeChannel.id);
      };

      
      }
  }, [activeChannel,isSignalRConnected]);
  
  useEffect(() => {
    if (activeSite && isSignalRConnected) {
        chatHub.joinSite(activeSite.id);
        return () => {
            chatHub.leaveSite(activeSite.id);
        };
    }
}, [activeSite, isSignalRConnected]);
  // Скролл к последнему сообщению
  /*
  useEffect(() => {
    scrollToBottom();
  }, [messages]);
*/
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const getDefaultSiteIdFromUrl = () => {
    // Декодируем путь, чтобы кириллица совпадала
    const path = decodeURIComponent(window.location.pathname);
    
    // Убираем слэш на конце (если есть)
    const cleanPath = path.replace(/\/$/, '') || '/';
    
    return SITE_SHORTCUTS[cleanPath] || null;
};


  const loadUserSites = async () => {
    try {
      const sitesData = await sitesService.getUserSitesWithUnread();
      const sitesList = Array.isArray(sitesData) ? sitesData : [];
      setSites(sitesList);

      // 1. Проверяем ярлык из URL
      const shortcutSiteId = getDefaultSiteIdFromUrl();
        
      if (shortcutSiteId) {
          const targetSite = sitesList.find(s => s.id === shortcutSiteId);
          
          if (targetSite) {
              console.log(`🎯 Переход по ярлыку на сайт: ${targetSite.name}`);
              setActiveSite(targetSite);
              
              // Очищаем URL, чтобы F5 не возвращал на ярлык
              //window.history.replaceState({}, '', '/');
              
              setLoading(false);
              return;
          } else {
              console.warn(`⚠️ Сайт из ярлыка (${shortcutSiteId}) не найден у пользователя`);
          }
      }

      // Заполняем непрочитанные для каждого сайта
      const counts = {};
      sitesList.forEach(site => {
          if (site.unreadCount > 0) counts[site.id] = site.unreadCount;
      });
      setSiteUnreadCounts(counts);

      // Восстанавливаем последний активный сайт
      const { siteId, channelId } = loadLastActive();
      if (siteId && sitesList.length > 0) {
        const siteToSelect = sitesList.find(s => s.id === siteId) || sitesList[0];
        setActiveSite(siteToSelect);
      }

      // if (sitesData.length > 0) {
      //   setActiveSite(sitesList[0]);
      // }
      setLoading(false);
    } catch (error) {
      console.error('Ошибка загрузки сайтов:', error);
      setLoading(false);
    }
  };

  const loadSiteChannels = async (siteId) => {
    try {
      const channelsData = await sitesService.getSiteChannels(siteId);
      const channelIdSaved = localStorage.getItem('lastChannelId');
      setChannels(channelsData);
      
      // Заполняем непрочитанные
      const counts = {};
      channelsData.forEach(ch => {
          if (ch.unreadCount > 0) counts[ch.id] = ch.unreadCount;
      });
      setUnreadCounts(counts);

      if (channelsData.length > 0) {
        // Ищем канал по ID (включая личные и избранное)
        const { siteId, channelId } = loadLastActive();
        const channelToSelect = channelsData.find(c => c.id === channelId) || channelsData[0];
        if (channelToSelect) {
          setActiveChannel(channelToSelect);
          
          // Если у канала есть сайт — восстанавливаем его
          if (channelToSelect.siteId && sites.length > 0) {
            const siteToSelect = sites.find(s => s.id === channelToSelect.siteId) || sites[0];
            setActiveSite(siteToSelect);
          }
        }
      }

      // if (channelIdSaved === undefined && channelsData.length > 0) {
      //   setActiveChannel(channelsData[0]);
      // }
    } catch (error) {
      console.error('Ошибка загрузки каналов:', error);
    }
  };

  const loadMessages = async (channelId, beforeId = null) => {
    try {
      if (!beforeId) {
        setLoading(true);
        setShouldScrollToBottom(true); // Первая загрузка — скролл вниз
      } else {
        setIsLoadingMore(true);
        setShouldScrollToBottom(false); // Подгрузка старых — не скроллить
      }
      
      //const messagesData = await channelsService.getMessages(channelId, 20, beforeId);
      const messagesData = await channelsService.getMessagesWithRead(channelId, 20, beforeId);
      if (beforeId) {
        setMessages(prev => [...messagesData, ...prev]);
      } else {
        setMessages(messagesData);
      }
      
      setHasMoreMessages(messagesData.length === 20);
      setIsLoadingMore(false);
      setLoading(false);
    } catch (error) {
      console.error('Ошибка загрузки сообщений:', error);
      setLoading(false);
      setIsLoadingMore(false);
    }
  };
/*
  const loadMoreMessages = () => {
    if (messages.length > 0 && hasMoreMessages && !isLoadingMore) {
      const oldestMessageId = messages[0].id;
      loadMessages(activeChannel.id, oldestMessageId);
    }
  };
*/

  // Добавьте ref для наблюдателя
const loadMoreRef = useRef(null);
const messagesAreaRef = useRef(null);
const scrollHeightBeforeRef = useRef(0);
const isLockedRef = useRef(false);

// Убедитесь, что loadMoreMessages использует useCallback
const loadMoreMessages = useCallback(async () => {
  if (isLockedRef.current) return;
  isLockedRef.current = true;

  if (messages.length > 0 && hasMoreMessages && !isLoadingMore) {
    // Сохраняем текущую высоту прокрутки перед загрузкой
    if (messagesAreaRef.current) {
      scrollHeightBeforeRef.current = messagesAreaRef.current.scrollHeight;
    }

    setIsLoadingMore(true);
    const oldestMessageId = messages[0].id;
    await loadMessages(activeChannel.id, oldestMessageId);
    setIsLoadingMore(false);

    // Восстанавливаем позицию прокрутки после загрузки
    if (messagesAreaRef.current) {
      const newScrollHeight = messagesAreaRef.current.scrollHeight;
      const scrollDelta = newScrollHeight - scrollHeightBeforeRef.current;
      messagesAreaRef.current.scrollTop += scrollDelta+50;
    }
  }

  isLockedRef.current = false;
}, [messages, hasMoreMessages, isLoadingMore, activeChannel, loadMessages]);

useEffect(() => {
  if (!loadMoreRef.current || !hasMoreMessages || isLoadingMore) return;

  const observer = new IntersectionObserver(
    (entries) => {
      
      if (entries[0].isIntersecting && hasMoreMessages && !isLoadingMore) {
        //console.log('✅ Загружаем сообщения...');
        loadMoreMessages();
        observer.disconnect();
      }
    },
    { threshold: 0.1 }
  );

  observer.observe(loadMoreRef.current);
  return () => observer.disconnect();
}, [hasMoreMessages, isLoadingMore, loadMoreMessages]);

  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (!inputMessage.trim() || !activeChannel) return;

    //console.log('Отправка сообщения в канал:', activeChannel.id);
    //console.log('Текст сообщения:', inputMessage);
    
    try {
      // Извлекаем упоминания @username
      const mentionRegex = /@([\p{L}\p{N}_]+)/gu;
      //const mentionRegex = /@(\p{L}+)/gu;
      const matches = inputMessage.matchAll(mentionRegex);
      const mentionedUsernames = [...matches].map(m => m[1]);
      
      // Находим ID пользователей по username
      const members = allChannelMembers[activeChannel?.id] || [];
      const mentionedUserIds = members
        .filter(m => mentionedUsernames.includes(m.username))
        .map(m => m.id);
      //await chatHub.sendMessage(activeChannel.id, inputMessage);
      await chatHub.sendMessage(
        activeChannel.id,
        inputMessage,
        mentionedUserIds,
        replyToMessage?.id || null // Передаём ID сообщения, на которое отвечаем
      );
      setInputMessage('');
      setShouldScrollToBottom(true); // После отправки — скролл вниз
      setReplyToMessage(null);

      chatHub.markChannelAsRead(activeChannel.id);
    } catch (error) {
      console.error('❌ Ошибка отправки через SignalR:', error);
    }
  };

  const handleFileUpload = async (e) => {
    const files = Array.from(e.target.files);
    if (!files || files.length === 0 || !activeChannel) {
      e.target.value = '';
      return;
    }
    
    const oversizedFile = files.find(file => file.size > MAX_FILE_SIZE);
    if (oversizedFile) {
        alert(`Файл "${oversizedFile.name}" слишком большой. Максимальный размер: 1 ГБ.`);
        e.target.value = '';
        return;
    }

    // Показываем индикатор загрузки, если нужно
    setIsCreatingChannel?.(true) // или своё состояние для загрузки файлов
  
    try {
      const tempIds = files.map(file => addUploadingMessage(file.name, file.size, file.type));

      // Загружаем файлы с прогрессом
        const uploadPromises = files.map((file, index) => {
            return filesService.uploadFile(file, 'attachments', (progress) => {
                setUploadingMessages(prev =>
                    prev.map(msg => 
                        msg.id === tempIds[index] ? { ...msg, progress } : msg
                    )
                );
                scrollToBottom();
            });
        });

        const results = await Promise.all(uploadPromises);
        
        const messageText = inputMessage.trim();
        await chatHub.sendMultipleAttachments(
            activeChannel.id,
            results,
            messageText
        );

        // Удаляем временные сообщения
        setUploadingMessages(prev => prev.filter(msg => !tempIds.includes(msg.id)));
        setInputMessage('');
    } catch (error) {
      console.error('❌ Ошибка загрузки файлов:', error);
      // Добавьте уведомление пользователю
    } finally {
      // Сбрасываем инпут
      e.target.value = '';
      setIsCreatingChannel?.(false);
    }
  };

  const handleCallToggle = () => {
    if (messagesAreaRef.current) {
      setChatScrollPosition(messagesAreaRef.current.scrollTop);
    }
    setIsInCall(!isInCall);
    
  };

  useEffect(() => {
    if (messagesAreaRef.current && chatScrollPosition > 0) {
      messagesAreaRef.current.scrollTop = chatScrollPosition;
    }
  }, [isInCall]);

  useEffect(() => {
    if (messagesAreaRef.current && chatScrollPosition > 0) {
      messagesAreaRef.current.scrollTop = chatScrollPosition;
    }
  }, [isGalleryOpen]);
  //const channelIdForCall = activeChannel?.id || '';

  const handleTyping = () => {
    if (activeChannel) {
      chatHub.typing(activeChannel.id);
    }
  };

  // Получаем имя канала без символа #
  const currentChannelName = activeChannel ? activeChannel.name : '';

   // Открытие модального окна
   const openCreateSiteModal = () => {
    setIsCreateSiteModalOpen(true);
  };

  // Закрытие модального окна
  const closeCreateSiteModal = () => {
    setIsCreateSiteModalOpen(false);
    setNewSiteName('');
    setNewSiteDescription('');
    setNewSiteIcon(null);
    setIsCreatingSite(false);
  };

  // Загрузка иконки сайта
  const handleSiteIconUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    
    try {
      const result = await filesService.uploadFile(file, 'site-icons');
      setNewSiteIcon(result.url);
    } catch (error) {
      console.error('Ошибка загрузки иконки:', error);
    }
  };

  // Создание сайта
  const handleCreateSite = async () => {
    if (!newSiteName.trim()) return;
    
    setIsCreatingSite(true);
    try {
      const siteData = {
        name: newSiteName,
        description: newSiteDescription || '',
        icon: newSiteIcon || null
      };
      
      const createdSite = await sitesService.createSite(siteData);
      //console.log('Сайт создан:', createdSite);
      
      // Добавляем участников
      if (selectedMemberIds.length > 0) {
        for (const userId of selectedMemberIds) {
          await sitesService.addMember(createdSite.id, userId);
        }
      }
      
      // Обновляем список сайтов
      const updatedSites = await sitesService.getUserSites();
      setSites(updatedSites);
      
      closeCreateSiteModal();
    } catch (error) {
      console.error('Ошибка создания сайта:', error);
    } finally {
      setIsCreatingSite(false);
    }
  };

  // Удаление сайта (мягкое удаление)
  const handleDeleteSite = async (siteId) => {
    if (!window.confirm('Вы уверены, что хотите удалить этот сайт?')) return;
    
    try {
      await sitesService.deleteSite(siteId);
      
      // Обновляем список сайтов
      const updatedSites = await sitesService.getUserSites();
      setSites(updatedSites);
      
      // Если удаленный сайт был активным, выбираем первый доступный
      if (activeSite?.id === siteId && updatedSites.length > 0) {
        setActiveSite(updatedSites[0]);
      } else if (updatedSites.length === 0) {
        setActiveSite(null);
      }
    } catch (error) {
      console.error('Ошибка удаления сайта:', error);
    }
  };
  // Загрузка всех пользователей
  useEffect(() => {
      const loadAllUsers = async () => {
          try {
              const response = await authService.getAllUsers();
              setAllUsers(response);
          } catch (error) {
              console.error('Ошибка загрузки пользователей:', error);
          }
      };
      
      loadAllUsers();
  }, []);

  const handleContextMenu = (e, site) => {
    e.preventDefault();
    // Показываем контекстное меню только если пользователь - владелец
    if (site.ownerId === user.id || user.roles?.includes('admin')) {
        setContextMenu({ x: e.clientX, y: e.clientY, site });
    }
};

const handleCloseContextMenu = () => {
    setContextMenu(null);
};

const handleEditSite = () => {
    if (!contextMenu) return;
    const site = contextMenu.site;
    setEditingSite(site);
    setEditSiteName(site.name);
    setEditSiteDescription(site.description || '');
    setEditSiteIcon(site.icon || null);
    // Загружаем участников сайта
    loadSiteMembers(site.id);
    setContextMenu(null);
};

const handleUpdateSite = async () => {
  if (!editingSite || !editSiteName.trim()) return;
  
  setIsUpdatingSite(true);
  try {
      const updateData = {
          name: editSiteName,
          description: editSiteDescription || '',
          icon: editSiteIcon || null
      };
      
      // Обновляем основные данные сайта
      await sitesService.updateSite(editingSite.id, updateData);
      
      // Обновляем участников сайта
      // Получаем текущих участников
      //const currentMembers = await sitesService.getSiteMembers(editingSite.id);
      
      const currentMemberIds = siteMembers.map(m => m.userId);
      
      // Добавляем новых участников
      const membersToAdd = selectedEditMembers.filter(id => !currentMemberIds.includes(id));
      for (const userId of membersToAdd) {
          await sitesService.addMember(editingSite.id, userId);
      }
      
      // Удаляем участников, которых убрали
      const membersToRemove = currentMemberIds.filter(id => !selectedEditMembers.includes(id));
      for (const userId of membersToRemove) {
        const targetMember = siteMembers.find(m => m.userId === userId);
        if (targetMember) {
            await sitesService.removeMember(editingSite.id, targetMember.userId);
        }
      }
      
      // Обновляем список сайтов
      const updatedSites = await sitesService.getUserSites();
      setSites(updatedSites);
      
      // Закрываем модальное окно
      setEditingSite(null);
      setIsUpdatingSite(false);
      //console.log('✅ Сайт обновлен');
  } catch (error) {
      console.error('❌ Ошибка обновления сайта:', error);
      setIsUpdatingSite(false);
  }
};
const loadSiteMembers = async (siteId) => {
  try {
      const members = await sitesService.getSiteMembers(siteId);
      const membersWithUserData = members.map(member => {
        const user = allUsers.find(u => u.id === member.userId);
        return {
            ...member,
            username: user?.username || 'Неизвестный',
            email: user?.email || '',
            firstName: user?.firstName || '',
            lastName: user?.lastName || '',
            userId: user?.id || ''
        };
    });
    
    setSiteMembers(membersWithUserData);
    setSelectedEditMembers(membersWithUserData.map(m => m.userId));
      //setSiteMembers(members);
      //setSelectedEditMembers(members.map(m => m.id));
  } catch (error) {
      console.error('Ошибка загрузки участников сайта:', error);
  }
};
const handleEditSiteIconUpload = async (e) => {
  const file = e.target.files[0];
  if (!file) return;
  
  try {
      const result = await filesService.uploadFile(file, 'site-icons');
      setEditSiteIcon(result.url);
  } catch (error) {
      console.error('Ошибка загрузки иконки:', error);
  }
};
// Открытие модального окна для создания канала
const openCreateChannelModal = () => {
  setEditingChannel(null);
  setChannelName('');
  setChannelTopic('');
  setChannelPosition(channels.length); // Новый канал в конце списка
  setIsChannelModalOpen(true);
  loadCollectionSets();
};

// Открытие модального окна для редактирования канала
const openEditChannelModal = (channel) => {
  setEditingChannel(channel);
  setChannelName(channel.name);
  setChannelTopic(channel.topic || '');
  setChannelPosition(channel.position || 0);
  
  setChannelType(channel.type || 'text');
  setAreas(channel.areas || []);
  setCollectionSetId(channel.collectionSetId || '');

  setIsChannelModalOpen(true);
  setChannelContextMenu(null);
  loadCollectionSets();
};

// Закрытие модального окна
const closeChannelModal = () => {
  setIsChannelModalOpen(false);
  setEditingChannel(null);
  setChannelName('');
  setChannelTopic('');
  setIsCreatingChannel(false);
};

const handleChannelSubmit = async () => {
  if (!channelName.trim()) return;
  
  setIsCreatingChannel(true);
  try {
      if (editingChannel) {
          // Обновление существующего канала
          await channelsService.updateChannel(editingChannel.id, {
              name: channelName,
              topic: channelTopic,
              position: channelPosition,
              type: channelType, 
              areas: areas,
              collectionSetId: collectionSetId 
          });
          //console.log('✅ Канал обновлен');
      } else {
          // Создание нового канала
          const newChannel = await channelsService.createChannel({
              siteId: activeSite.id,
              name: channelName,
              topic: channelTopic,
              position: channelPosition,
              type: channelType, 
              areas: areas,
              collectionSetId: collectionSetId
          });
          //console.log('✅ Канал создан:', newChannel);
      }
      
      // Обновляем список каналов
      const updatedChannels = await sitesService.getSiteChannels(activeSite.id);
      setChannels(updatedChannels);
      closeChannelModal();
  } catch (error) {
      console.error('❌ Ошибка сохранения канала:', error);
  } finally {
      setIsCreatingChannel(false);
  }
};

// Удаление канала
const handleDeleteChannel = async (channelId) => {
  if (!window.confirm('Вы уверены, что хотите удалить этот канал?')) return;
  
  try {
      await channelsService.deleteChannel(channelId);
      //console.log('✅ Канал удален');
      
      // Обновляем список каналов
      const updatedChannels = await sitesService.getSiteChannels(activeSite.id);
      setChannels(updatedChannels);
      
      // Если удаленный канал был активным, сбрасываем выбор
      if (activeChannel?.id === channelId) {
          setActiveChannel(updatedChannels.length > 0 ? updatedChannels[0] : null);
      }
      
      setChannelContextMenu(null);
  } catch (error) {
      console.error('❌ Ошибка удаления канала:', error);
  }
};

// Контекстное меню для канала
const handleChannelContextMenu = (e, channel) => {
  e.preventDefault();
  setChannelContextMenu({ x: e.clientX, y: e.clientY, channel });
};

const closeChannelContextMenu = () => {
  setChannelContextMenu(null);
};

const formatMessageDate = (date) => {
  const now = new Date();
  const messageDate = new Date(date);
  const diff = now - messageDate;
  const oneDay = 24 * 60 * 60 * 1000;
  
  if (diff < oneDay && now.getDate() === messageDate.getDate()) {
    // Сегодня — только время
    return messageDate.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
  } else if (diff < 2 * oneDay) {
    // Вчера — "Вчера, время"
    return `Вчера, ${messageDate.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })}`;
  } else {
    // Старше — полная дата
    return messageDate.toLocaleString('ru-RU', {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }
};
// Скролл вниз только при получении новых сообщений
useEffect(() => {
  if (shouldScrollToBottom) {
    scrollToBottom();
    
  }
}, [messages, shouldScrollToBottom]);

// Копирование файлов изображение
const handlePaste = async (e) => {
  const items = (e.clipboardData || e.originalEvent.clipboardData)?.items;
  if (!items) return;

  // Проходим по всем элементам буфера обмена
  for (const item of items) {
    if (item.type.startsWith('image/')) {
      e.preventDefault(); // Предотвращаем вставку текста
      
      const file = item.getAsFile();
      await handlePasteImage(file);
      break; // Обрабатываем только первое изображение
    }
    if (item.type.indexOf('image') !== -1) {
      e.preventDefault(); // Предотвращаем вставку текста
      
      const file = item.getAsFile();
      await handlePasteImage(file);
      break;
    }
  }
};

const handlePasteImage = async (file) => {
  if (!file || !activeChannel) return;

  if (file.size > MAX_FILE_SIZE) {
    alert(`Файл "${file.name}" слишком большой. Максимальный размер: 1 ГБ.`);
    return;
  }

  const tempId = addUploadingMessage(file.name, file.size, file.type);
  try {
    const result = await filesService.uploadFile(file, 'attachments', (progress) => {
      setUploadingMessages(prev =>
          prev.map(msg => msg.id === tempId ? { ...msg, progress } : msg)
      );
      scrollToBottom();
    });

    const messageText = inputMessage.trim();
    await chatHub.sendMultipleAttachments(activeChannel.id, [result], messageText);

    setUploadingMessages(prev => prev.filter(msg => msg.id !== tempId));
    setInputMessage('');
  } catch (error) {
    console.error('❌ Ошибка загрузки изображения:', error);
  }
};

//загрузка участников канала
const loadChannelParticipants = useCallback(async (channelId) => {
  try {
    // Получаем участников канала через API
    const members = await channelsService.getActiveChannelMembers(channelId);
    setChannelParticipants(prev => ({
      ...prev,
      [channelId]: members
    }));
  } catch (error) {
    console.error('Ошибка загрузки участников канала:', error);
  }
}, []);

useEffect(() => {
  if (activeChannel) {
    loadChannelParticipants(activeChannel.id);
  }
}, [activeChannel, loadChannelParticipants]);

const loadAllChannelParticipants = useCallback(async () => {
  if (!channels || channels.length === 0) return;
  
  try {
    const promises = channels.map(channel => 
      channelsService.getActiveChannelMembers(channel.id)
        .then(members => ({ channelId: channel.id, members }))
        .catch(error => {
          console.error(`Ошибка загрузки участников для канала ${channel.name}:`, error);
          return { channelId: channel.id, members: [] };
        })
    );
    
    const results = await Promise.all(promises);
    
    const newParticipants = {};
    results.forEach(({ channelId, members }) => {
      newParticipants[channelId] = members;
    });
    
    setChannelParticipants(newParticipants);
  } catch (error) {
    console.error('Ошибка загрузки участников всех каналов:', error);
  }
}, [channels]);

useEffect(() => {
  if (activeChannel) {
    loadAllChannelParticipants();
  }
}, [activeChannel, loadAllChannelParticipants]);

//Уведомления
const playNotificationSoundP = () => {
  // На телефонах — вибрация
  if (navigator.vibrate) {
    navigator.vibrate(200);
  }
  
  // В браузере — уведомление с одним системным звуком
  // if (Notification.permission === 'granted') {
  //   new Notification('Новое сообщение', {
  //     body: 'У вас новое сообщение в чате',
  //     silent: false
  //   });
  // }

  if (Notification.permission === 'default') {
    Notification.requestPermission();
  }
};
//редактирование сообщений
const handleMessageContextMenu = (e, message) => {
  e.preventDefault();
  if (message.authorId === user.id) {
    setContextMenuEditMessage({ 
      x: e.clientX, 
      y: e.clientY, 
      messageId: message.id, 
      content: message.content 
    });
  }
};

const closeMessageContextMenu = () => {
  setContextMenuEditMessage(null);
  setEditingMessageId(null);
};

const handleEditMessage = () => {
  if (!contextMenuEditMessage) return;
  setEditingMessageId(contextMenuEditMessage.messageId);
  setEditMessageContent(contextMenuEditMessage.content);
  setContextMenuEditMessage(null);
};

const handleDeleteMessage = async () => {
  if (!contextMenuEditMessage) return;
  if (!window.confirm('Вы уверены, что хотите удалить это сообщение?')) return;
  
  try {
    await chatHub.deleteMessage(contextMenuEditMessage.messageId);
    setContextMenuEditMessage(null);
  } catch (error) {
    console.error('Ошибка удаления сообщения:', error);
  }
};

const handleSaveEdit = async () => {
  if (!editingMessageId || !editMessageContent.trim()) return;
  
  try {
    await chatHub.editMessage(editingMessageId, editMessageContent);
    setEditingMessageId(null);
    setEditMessageContent('');
    //console.log('✅ Сообщение отредактировано');
  } catch (error) {
    console.error('❌ Ошибка редактирования сообщения:', error);
  }
};

const handleCancelEdit = () => {
  setEditingMessageId(null);
  setEditMessageContent('');
};

//Оставление реакции
const handleMessageClick = (e, message) => {
  // Если выделен текст — не открываем панель реакций
  if (window.getSelection().toString().length > 0) {
    return;
  }

  if (editingMessageId !== message.id) {
    const rect = e.currentTarget.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    
    // Определяем, сколько места осталось снизу
    const spaceBelow = windowHeight - rect.bottom;
    const pickerHeight = 120; // Примерная высота панели реакций
    
    let x = rect.left;
    let y;
    
    // Если места снизу достаточно — показываем под сообщением
    if (spaceBelow >= pickerHeight) {
      y = rect.bottom + 10;
    } else {
      // Иначе показываем над сообщением
      y = rect.top - pickerHeight - 10;
    }
    
    // Корректируем по горизонтали, если панель уходит за правый край
    if (x + 320 > window.innerWidth) {
      x = window.innerWidth - 330;
    }
    
    setReactionPickerPosition({ x, y });
    setShowReactionPicker(message.id);
  }
};
const handleReaction = async (messageId, emoji) => {
  try {
    await chatHub.addReaction(messageId, emoji);
    setShowReactionPicker(null);
  } catch (error) {
    console.error('Ошибка добавления реакции:', error);
  }
};

const handleRemoveReaction = async (messageId, emoji) => {
  try {
    await chatHub.removeReaction(messageId, emoji);
  } catch (error) {
    console.error('Ошибка удаления реакции:', error);
  }
};

useEffect(() => {
  const handleClickOutside = (e) => {
    if (showReactionPicker) {
      // Проверяем, был ли клик внутри панели реакций
      const picker = document.querySelector('.reaction-picker');
      if (picker && !picker.contains(e.target)) {
        setShowReactionPicker(null);
      }
    }
  };
  
  document.addEventListener('mousedown', handleClickOutside);
  return () => document.removeEventListener('mousedown', handleClickOutside);
}, [showReactionPicker]);

//Избранное
const handleSaveMessage = async (messageId) => {
  if (!messageId) return;
  try {
    await favoritesService.saveMessage(messageId);
    setSavedMessageIds(prev => [...prev, messageId]);
    setContextMenuEditMessage(null);
  } catch (error) {
    console.error('Ошибка сохранения:', error);
  }
};

const handleUnsaveMessage = async (messageId) => {
  if (!messageId) return;
  try {
    await favoritesService.unsaveMessage(messageId);
    setSavedMessageIds(prev => prev.filter(id => id !== messageId));
    setContextMenuEditMessage(null);
  } catch (error) {
    console.error('Ошибка удаления из избранного:', error);
  }
};

const loadSavedMessageIds = async () => {
  try {
    const messages = await favoritesService.getFavoriteMessages();
    // Извлекаем ID оригинальных сообщений
    const ids = messages.map(msg => msg.originalMessageId || msg.id);
    setSavedMessageIds(ids);
  } catch (error) {
    console.error('Ошибка загрузки избранных ID:', error);
  }
};

useEffect(() => {
  loadSavedMessageIds();
}, []);

// Сохраняем в localStorage
const saveLastActive = (siteId, channelId) => {
  if (channelId) {
    localStorage.setItem('lastChannelId', channelId);
    // Сохраняем сайт только если он есть (для обычных каналов)
    if (siteId) {
      localStorage.setItem('lastSiteId', siteId);
    } else {
      localStorage.removeItem('lastSiteId');
    }
  }
};

// Загружаем из localStorage
const loadLastActive = () => {
  const siteId = localStorage.getItem('lastSiteId');
  const channelId = localStorage.getItem('lastChannelId');
  return { siteId, channelId };
};

// При выборе сайта
const handleSiteChange = (site) => {
  setActiveSite(site);
  // Если есть каналы, выбираем первый или сохранённый
  const savedChannelId = localStorage.getItem('lastChannelId');
  const channelToSelect = channels.find(c => c.id === savedChannelId) || channels[0];
  if (channelToSelect) {
    setActiveChannel(channelToSelect);
    saveLastActive(site.id, channelToSelect.id);
  }
};

// При выборе канала
const handleChannelChange = (channel) => {
  setActiveChannel(channel);
  // Если канал принадлежит сайту — сохраняем сайт
  if (channel.siteId) {
    saveLastActive(channel.siteId, channel.id);
  } else {
    // Личный канал или избранное — сохраняем только канал
    saveLastActive(null, channel.id);
  }
};

useEffect(() => {
  const { siteId, channelId } = loadLastActive();
  if(siteId)
  {
    
  }
  else
  {
    setViewMode('settings');
    
  }
  // Сначала пытаемся восстановить канал
  
}, [sites, channels]);


const isFavoriteChannel = activeChannel && activeChannel.name === '⭐ Избранное';

//Ответить на сообщение
const handleReplyClick = (message) => {
  //if (message.authorId === user.id) return; // Нельзя отвечать на свои сообщения
  setReplyToMessage(message);
};

//Поиск
const handleSearch = async () => {
  if (!searchQuery.trim() || !activeChannel) return;
  
  setIsSearching(true);
  try {
    // Отправляем запрос на бэкенд
    const results = await channelsService.searchMessages(activeChannel.id, searchQuery);
    setSearchResults(results);
    setIsSearchMode(true);
  } catch (error) {
    console.error('Ошибка поиска:', error);
  } finally {
    setIsSearching(false);
  }
};

const closeSearch = () => {
  setIsSearchMode(false);
  setSearchQuery('');
  setSearchResults([]);
};

//Отмечать пользователей
const handleInputChange = (e) => {
  const text = e.target.innerText || e.target.value || '';
  const lastAt = text.lastIndexOf('@');
  
  if (lastAt !== -1) {
    const searchTerm = text.substring(lastAt + 1);
    setMentionSearch(searchTerm);
    
    // Фильтруем участников канала
    const members = allChannelMembers[activeChannel?.id] || [];
    const filtered = members.filter(m => 
      m.username.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setMentionSuggestions(filtered);
    setShowMentions(filtered.length > 0);
  } else {
    setShowMentions(false);
  }
};

const handleMentionSelect = (user) => {
  const text = inputMessage;
  const lastAt = text.lastIndexOf('@');
  
  if (lastAt !== -1) {
    const before = text.substring(0, lastAt);
    const after = text.substring(lastAt + mentionSearch.length + 1);
    setInputMessage(`${before}@${user.username} ${after}`);
  }
  
  setShowMentions(false);
  setMentionSuggestions([]);
};

// Функция загрузки всех участников канала
const loadAllChannelMembers = async (channelId) => {
  try {
    const members = await channelsService.getAllChannelMembers(channelId);
    setAllChannelMembers(prev => ({
      ...prev,
      [channelId]: members
    }));
  } catch (error) {
    console.error('Ошибка загрузки всех участников канала:', error);
  }
};

useEffect(() => {
  if (activeChannel) {
    loadAllChannelMembers(activeChannel.id);
  }
}, [activeChannel]);

//Галерея
const loadChannelImages = async () => {
  if (!activeChannel) return;
  
  // Запоминаем текущую позицию скролла
  if (messagesAreaRef.current) {
    setChatScrollPosition(messagesAreaRef.current.scrollTop);
  }

  setIsLoadingGallery(true);
  try {
    // Теперь данные приходят уже в нужном формате
    const images = await channelsService.getChannelImages(activeChannel.id);
    setGalleryImages(images);
    setIsGalleryOpen(true);
  } catch (error) {
    console.error('Ошибка загрузки изображений:', error);
  } finally {
    setIsLoadingGallery(false);
  }
};

//Планирование 
const isFullHtmlDocument = (text) => {
  if (!text) return false;
  const trimmed = text.trim();
  return trimmed.startsWith('<!DOCTYPE html>') || trimmed.startsWith('<html>');
};

//Коллекции

const loadCollectionSets = async () => {
  if (!activeSite) return;
  try {
    const data = await collectionService.getSetsBySiteId(activeSite.id);
    setCollectionSets(data);
  } catch (error) {
    console.error('Ошибка загрузки наборов коллекций:', error);
  }
};
//Отправка вложений
const addUploadingMessage = (fileName, fileSize, fileType) => {
  const tempId = `upload_${Date.now()}_${Math.random()}`;
  const newTemp = {
      id: tempId,
      authorName: user.username || 'Вы',
      authorAvatar: user.avatarUrl,
      content: `📤 Загрузка: ${fileName}`,
      isUploading: true,
      progress: 0,
      fileName,
      fileSize,
      fileType,
      createdAt: new Date(),
  };
  setUploadingMessages(prev => [...prev, newTemp]);
  return tempId;
};

useEffect(() => {
  if (window.innerWidth > 768) return;

  // Измеряем разницу между полной высотой окна и видимой областью
  // Это и есть высота адресной строки
  const offset = window.innerHeight - window.visualViewport.height;
  
  // Применяем смещение, только если оно больше 10px
  if (offset > 10) {
      document.documentElement.style.setProperty('--top-offset', `${offset}px`);
  } else {
      document.documentElement.style.setProperty('--top-offset', '0px');
  }
}, []);

//Мигающий огонек
const loadDirectMessageUnread = async () => {
  try {
      const data = await channelsService.getPrivateChannels();
      
      // Формируем карту: { otherUserId: unreadCount }
      const unreadMap = {};
      data.forEach(chat => {
          if (chat.unreadCount > 0 && chat.otherUserId) {
              unreadMap[chat.otherUserId] = chat.unreadCount;
          }
      });

      setDirectMessageUnread(unreadMap);
      console.log('📬 Непрочитанные DM загружены:', unreadMap);
  } catch (error) {
      console.error('Ошибка загрузки непрочитанных DM:', error);
  }
};

useEffect(() => {
  if (isSignalRConnected) {
      loadDirectMessageUnread();
  }
}, [isSignalRConnected]);

const formatUnreadCount = (count) => {
  if (count <= 999) return count.toString();
  if (count < 1000000) return (count / 1000).toFixed(1).replace('.0', '') + 'k';
  return (count / 1000000).toFixed(1).replace('.0', '') + 'M';
};

const totalDirectUnread = Object.values(directMessageUnread).reduce((sum, count) => sum + count, 0);
const isOwner = activeSite && user && activeSite.ownerId === user.id;
  return (
    <div className="server-container">
      {/* Sidebar - Server List */}
      <div className="server-sidebar">
        <div className="server-icon">
          {user?.avatarUrl ? (
            <img 
              src={user.avatarUrl} 
              alt={user.username || 'User'} 
              className="user-avatar-icon"
              onClick={() => setViewMode('settings')}
            />
          ) : (
            <div className="user-avatar-text" onClick={() => setViewMode('settings')}>
              {(user?.username?.[0] || 'U').toUpperCase()}
            </div>
          )}

          {/* Красный кружок */}
          {totalDirectUnread > 0 && (
              <span className="unread-badge-site blink">
                  {formatUnreadCount(totalDirectUnread)}
              </span>
          )}
        </div>
        <div className="server-divider"></div>
        {sites.map(site => (
          
          <div
            key={site.id}
            className={`server-icon ${activeSite?.id === site.id ? 'server-icon-primary' : ''}`}
            onClick={() => {
              setActiveSite(site);
              setViewMode('channels'); // При выборе сайта возвращаем режим каналов
              setSettingsMode('main');
              handleSiteChange(site);
            }}
            onContextMenu={(e) => handleContextMenu(e, site)}
          >
            {site.icon ? (
              <img 
                src={site.icon} 
                alt={site.name} 
                className="site-icon-img"
              />
            ) : (
              <div className="site-icon-text">
                {site.name.charAt(0).toUpperCase()}
              </div>
            )}

            {/* Красный мигающий кружок */}
            {siteUnreadCounts[site.id] > 0 && (
                <span className="unread-badge-site blink">
                    {formatUnreadCount(siteUnreadCounts[site.id])}
                </span>
            )}
          </div>
        ))}
        <div className="server-divider"></div>
        
        <div className="server-add-button" onClick={openCreateSiteModal}>
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
        </div>
      </div>

      {/* Channels Sidebar */}
      <div className="channels-sidebar">
      {viewMode === 'channels' ? (
        <>
        <div className="channels-header">
          <div className="server-name">{activeSite?.name || 'Сервер'}</div>
          <button className="server-dropdown">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
        </div>

        <div className="channels-list">
          {/*<div className="channel-category">Текстовые каналы</div>*/}
          {channels.map(channel => (
            <div 
              key={channel.id}
              onClick={() => {setActiveChannel(channel);}}
              onContextMenu={(e) => {
                if (isOwner) {
                  handleChannelContextMenu(e, channel);
                }
              }}
              className={`channel-item ${activeChannel?.id === channel.id ? 'channel-active' : ''}`}
            >
              <div className="channel-header">
                <span className="channel-hash"></span>
                <span>{channel.name}</span>
                {unreadCounts[channel.id] > 0 && (
                    <span className="unread-badge blink">{unreadCounts[channel.id]}</span>
                )}
              </div>
              
              {/* Список участников канала — вертикальный список */}
              {channelParticipants[channel.id]?.length > 0 && (
                <div className="channel-participants-vertical">
                  {channelParticipants[channel.id].map(member => (
                    <div key={member.userId} className="channel-participant-item">
                      <div className="channel-participant-avatar-wrapper">
                        <div className="channel-participant-avatar">
                          {member.avatarUrl ? (
                            <img src={member.avatarUrl} alt={member.username} className="channel-participant-img" />
                          ) : (
                            <div className="channel-participant-placeholder">
                              {member.username?.[0]?.toUpperCase() || '?'}
                            </div>
                          )}
                        </div>
                        <div className={`channel-participant-status-dot ${member.status === 'online' ? 'status-online' : 'status-offline'}`} />
                      </div>
                      <span className="channel-participant-name">{member.username}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
          {isOwner && (
              <div className="channel-add" onClick={openCreateChannelModal}>
                  <span>+ Добавить канал</span>
              </div>
          )}
          
          {/*<div className="channel-category">Пользователи</div>*/}
          {members.map(member => (
            <div key={member.id} className="user-item">
              <div className="user-avatar-wrapper">
                <div className="user-avatar-small">
                  {member.nickname?.charAt(0) || member.username?.charAt(0) || '?'}
                </div>
                <div className={`user-status-dot ${member.isOnline ? 'status-online' : 'status-offline'}`}></div>
              </div>
              <span className="user-name">{member.nickname || member.username}</span>
            </div>
          ))}
        </div>
        </>
        ) : (
          // Режим настроек пользователя
          <UserSettings 
            user={user} 
            directMessageUnread={directMessageUnread}
            onClose={() => {
              setViewMode('channels');
              setSettingsMode('main');
              
            }} 
            onUpdate={(updatedUser) => {
              // Обновляем данные пользователя
              //console.log('Пользователь обновлён:', updatedUser);
            }}
            onNavigate={(mode, channel) => 
                {
                  setSettingsMode(mode);
                  setActiveChannel(channel);
                //console.log('onNavigate вызван с mode:', mode);
              }}
              onLogout={onLogout} 
          />
        )}
      </div>

      {/* Main Content Area */}
      <div className="main-content">
        {/* 1. Галерея — имеет приоритет над всем */}
        {isGalleryOpen ? (
          <ImageGallery 
            images={galleryImages} 
            onClose={() => {setIsGalleryOpen(false);
              
            }} 
          />
        ) :
        activeChannel?.type === 'collectionset' && activeChannel? (
          <CollectionSetBoard channel={activeChannel} isOwner={isOwner} />
        ) : activeChannel?.type === 'collection' && activeChannel? (
          <CollectionBoard channel={activeChannel} collectionSetId={activeChannel.collectionSetId} isOwner={isOwner} />
        ) :
        activeChannel?.type === 'project'  && activeChannel? (
          <TasksBoard channel={activeChannel} />
        ) : 
         settingsMode === 'personal' ? (
      // Личные данные
      <PersonalData 
        user={user}
        onBack={() => setSettingsMode('main')}
      />
    ) : (
      <>
        
        {isInCall ? (
          <div className="split-view">
            {/* Левая часть - чат (300px) */}
            <div className="chat-section">
              {/* Chat Header with buttons */}
              <div className="chat-header">
                <div className="chat-header-left">
                  <span className="channel-hash">#</span>
                  <span className="channel-name">{currentChannelName}</span>
                </div>
                <div className="chat-header-right">
                  {/* Убрали кнопку запуска игры */}
                </div>
              </div>

              {/* Messages */}
              <div className="messages-area" ref={messagesAreaRef}>
                {/* Триггер для подгрузки старых сообщений — вверху списка */}
                {hasMoreMessages && (
                  <div ref={loadMoreRef} className="load-more-trigger-top">
                    {isLoadingMore && <div className="loading-spinner">Загрузка...</div>}
                  </div>
                )}
                
                {loading && <div className="loading">Загрузка сообщений...</div>}
                {!loading && messages.length === 0 && (
                  <div className="no-messages">Нет сообщений</div>
                )}
                {messages.map(msg => (
                <div 
                  key={msg.id} 
                  className="message-item" 
                  onContextMenu={(e) => handleMessageContextMenu(e, msg)}
                  onClick={(e) => handleMessageClick(e, msg)}
                >
                  <div className="message-avatar">
                    {msg.authorAvatar ? (
                      <img 
                        src={msg.authorAvatar} 
                        alt={msg.authorName || 'User'} 
                        className="message-avatar-img"
                      />
                    ) : (
                      <div className="message-avatar-text">
                        {msg.authorName?.charAt(0) || '?'}
                      </div>
                    )}
                  </div>
                  <div className="message-content">
                      <div className="message-header">
                        <span className="message-username">{msg.authorName}</span>
                        <span className="message-timestamp">
                          {formatMessageDate(msg.createdAt)}
                          {msg.isEdited && <span className="edited-badge">(ред.)</span>}
                        </span>
                        {/* Реакции */}
                        <MessageReactions 
                          message={msg}
                          currentUserId={user.id}
                          onUpdate={(updatedMessage) => {
                            setMessages(prev => prev.map(m => 
                              m.id === updatedMessage.id ? updatedMessage : m
                            ));
                          }}
                          />
                        {!isFavoriteChannel && (
                        <button
                          className={`save-star-btn ${savedMessageIds.includes(msg.id) ? 'saved' : ''}`}
                          onClick={() => {
                            if (savedMessageIds.includes(msg.id)) {
                              handleUnsaveMessage(msg.id);
                            } else {
                              handleSaveMessage(msg.id);
                            }
                          }}
                        >
                          {savedMessageIds.includes(msg.id) ? '⭐' : '☆'}
                        </button>
                        )}
                        <div className="message-read-status">
                          {msg.isReadByAllParticipants ? (
                            <span className="read-all" title="Прочитано всеми">✅</span>
                          ) : msg.readUsers?.length > 0 ? (
                            <span className="read-some" title={`Прочитано ${msg.readUsers?.length} участниками`}>
                              ✓ {msg.readUsers?.length}
                            </span>
                          ) : null}
                        </div>

                        {msg.readUsers?.length > 0 && (
                          <div className="read-avatars">
                            {msg.readUsers.map(user => (
                              <div key={user.id} className="read-avatar-wrapper" title={user.name}>
                                {user.avatarUrl ? (
                                  <img 
                                    src={user.avatarUrl} 
                                    alt={user.name} 
                                    className="read-avatar-img"
                                  />
                                ) : (
                                  <div className="read-avatar-letter">
                                    {user.name?.charAt(0)?.toUpperCase() || '?'}
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        )}
                        {/* Кнопка ответа — появляется при наведении */}
                        <button 
                          className="reply-btn"
                          onClick={() => handleReplyClick(msg)}
                          title="Ответить на сообщение"
                        >
                          ↩️
                        </button>
                      </div>
                      
                      {/* Если это ответ — показываем цитату */}
                      {msg.replyTo && (
                      <div className="message-reply-to">
                        <div className="reply-to-header">
                          <div className="reply-to-avatar">
                            {msg.replyToAuthorAvatar ? (
                              <img src={msg.replyToAuthorAvatar} alt={msg.replyToAuthorName} className="reply-to-avatar-img" />
                            ) : (
                              <div className="reply-to-avatar-placeholder">
                                {msg.replyToAuthorName?.charAt(0)?.toUpperCase() || '?'}
                              </div>
                            )}
                          </div>

                          <div className="reply-to-info">
                            <span className="reply-to-author">
                              {msg.replyToAuthorName }:
                            </span>
                          </div>
                        </div>
                        
                        <div className="reply-to-content">
                          {/* Текст исходного сообщения с linkify */}
                          {msg.replyToContent && (
                            <div dangerouslySetInnerHTML={{ __html: linkify(msg.replyToContent).replace(/@([\p{L}\p{N}_]+)/gu, '<span class="mention">$1</span>') }} />
                          )}

                          {/* Вложения исходного сообщения */}
                          {msg.replyToAttachments?.map(att => (
                            <div key={att.id} className="message-attachment">
                              {att.mimeType?.startsWith('image/') ? (
                                <img 
                                  src={att.url} 
                                  alt={att.fileName} 
                                  className="attachment-image" 
                                  onClick={() => handleImageClick(att.url)}
                                />
                              ) : att.mimeType?.startsWith('video/') ? (
                                <video 
                                  src={att.url} 
                                  controls 
                                  className="attachment-video"
                                  preload="metadata"
                                />
                              ) : (
                                <a href={att.url} target="_blank" rel="noopener noreferrer" className="attachment-link">
                                  📎 {att.fileName}
                                </a>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                      
                      {/* Режим редактирования */}
                      {editingMessageId === msg.id ? (
                        <div className="message-edit-mode">
                          <input
                            type="text"
                            value={editMessageContent}
                            onChange={(e) => setEditMessageContent(e.target.value)}
                            className="edit-input"
                            autoFocus
                          />
                          <div className="edit-actions">
                            <button onClick={handleSaveEdit} className="edit-save-btn">Сохранить</button>
                            <button onClick={handleCancelEdit} className="edit-cancel-btn">Отмена</button>
                          </div>
                        </div>
                      ) : (
                        
                      <div className="message-text">
                        {msg.content && (
                          <MarkdownRenderer content={msg.content} />
                        )}
                        {!msg.isDeleted && msg.attachments?.map(att => (
                          <div key={att.id} className="message-attachment">
                            {att.mimeType?.startsWith('image/') ? (
                              <img src={att.url} alt={att.fileName} className="attachment-image" onClick={() => handleImageClick(att.url)}/>
                            ) : att.mimeType?.startsWith('video/') ? (
                              <video 
                                src={att.url} 
                                controls 
                                className="attachment-video"
                                preload="metadata"
                              />
                            ): (
                              <a href={att.url} target="_blank" rel="noopener noreferrer" className="attachment-link">
                                📎 {att.fileName}
                              </a>
                            )}
                          </div>
                        ))}
                        {msg.isDeleted && <span className="deleted-text">(сообщение удалено)</span>}
                      </div>
                      )}
                    </div>
                    
                </div>
                
              ))}
                {uploadingMessages.map(msg => (
                    <div key={msg.id} className="message-item uploading-message">
                        <div className="message-avatar">
                            {msg.authorAvatar ? <img src={msg.authorAvatar} /> : msg.authorName[0]}
                        </div>
                        <div className="message-content">
                            <div className="message-header">
                                <span className="message-username">{msg.authorName}</span>
                                <span className="message-timestamp">
                                    {new Date(msg.createdAt).toLocaleTimeString()}
                                </span>
                            </div>
                            <div className="message-text">
                                <div className="uploading-file-info">
                                    <span>📤 {msg.fileName}</span>
                                    <span className="file-size">
                                        {(msg.fileSize / 1024 / 1024).toFixed(1)} MB
                                    </span>
                                </div>
                                <div className="upload-progress-bar">
                                    <div 
                                        className="upload-progress-fill" 
                                        style={{ width: `${msg.progress}%` }}
                                    />
                                    <span className="upload-progress-text">{msg.progress}%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
                

                <div ref={messagesEndRef} />
              </div>
              {/* Индикатор печатания */}
              {typingUser && (
                <div className="typing-indicator-wrapper">
                    {/* Плейсхолдер аватара, чтобы сдвинуть текст вправо как у сообщений */}
                    <div className="typing-avatar-placeholder"></div>
                    
                    <div className="typing-indicator-content">
                        <span className="typing-text">{typingUser} печатает</span>
                        <div className="typing-dots">
                            <span className="dot"></span>
                            <span className="dot"></span>
                            <span className="dot"></span>
                        </div>
                    </div>
                </div>
            )}                   
              {/* Input Area */}
              
              <div className="message-input-area">
                {/* Цитата, если есть ответ */}
                {replyToMessage && (
                  <div className="reply-preview">
                    <div className="reply-header">
                      <span className="reply-author">{replyToMessage.authorName}</span>
                      <button className="reply-close" onClick={() => setReplyToMessage(null)}>✕</button>
                    </div>
                    <div className="reply-content">
                      {replyToMessage.content?.substring(0, 100)}
                      {replyToMessage.content?.length > 100 && '...'}
                    </div>
                  </div>
                )}
                <form onSubmit={handleSendMessage} className="message-input-form">
                  <button 
                    type="button" 
                    className="message-input-btn"
                    onClick={() => fileInputRef.current?.click()}
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13" />
                    </svg>
                  </button>
                  <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileUpload}
                    style={{ display: 'none' }}
                    multiple
                  />
                  {showMentions && mentionSuggestions.length > 0 && (
                    <div className="mention-suggestions">
                      {mentionSuggestions.map(user => (
                        <div 
                          key={user.id} 
                          className="mention-suggestion-item"
                          onClick={() => handleMentionSelect(user)}
                        >
                          {user.avatarUrl ? (
                            <img src={user.avatarUrl} alt={user.username} className="mention-suggestion-avatar" />
                          ) : (
                            <div className="mention-suggestion-avatar-placeholder">
                              {user.username?.[0]?.toUpperCase() || '?'}
                            </div>
                          )}
                          <span className="mention-suggestion-name">{user.username}</span>
                        </div>
                      ))}
                    </div>
                  )}
                  <input
                    type="text"
                    ref={messageInputRef}
                    value={inputMessage}
                    onChange={(e) => {{setInputMessage(e.target.value);handleInputChange(e);}}}
                    onKeyDown={handleTyping}
                    onPaste={handlePaste}
                    placeholder="Введите текст..."
                    className="message-input"
                  />
                  <button type="submit" className="message-send-btn">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5" />
                    </svg>
                  </button>
                </form>
              </div>
            </div>

            {/* Правая часть - звонок */}
            <div className="call-section">
              <CallView
                onEndCall={handleCallToggle}
                participants={members.filter(m => m.isOnline)}
                currentUser={user}
                roomId={activeChannel?.id || ''}
                roomName={activeChannel?.name || ''}
              />
            </div>
          </div>
        ) : (
          <>
            {/* Chat Header with buttons */}
            <div className="chat-header">
              <div className="chat-header-left">
                <span className="channel-hash">#</span>
                <span className="channel-name">{currentChannelName}</span>
              </div>
              <div className="chat-header-right">
                {/* Кнопка поиска */}
                <button 
                  className="search-toggle-btn" 
                  onClick={() => setIsSearchMode(!isSearchMode)}
                  title="Поиск по сообщениям"
                >
                  🔍
                </button>

                {/* Поле поиска (появляется при нажатии) */}
                {isSearchMode && (
                  <div className="search-bar">
                    <input
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          handleSearch();
                        }
                      }}
                      placeholder="Поиск по сообщениям..."
                      className="search-input"
                      autoFocus
                    />
                    <button className="search-close-btn" onClick={() => closeSearch()}>
                      ✕
                    </button>
                  </div>
                )}

                 {/* Кнопка галереи */}
                <button className="gallery-toggle-btn" onClick={loadChannelImages}>
                  📷
                </button>
                {/* Кнопка начала звонка - зеленая */}
                {canCall && (
                <button
                  onClick={handleCallToggle}
                  className="call-button-start"
                  title="Начать звонок"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.740 4.435a1 1 0 01-.540 1.060l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.540l4.435.740a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.820 18 2 12.180 2 5V3z" />
                  </svg>
                </button>
                )}
              </div>
            </div>

            {/* Messages */}
            <div className="messages-area" ref={messagesAreaRef}>
                {/* Индикатор поиска */}
                {isSearchMode && (
                  <div className="search-status">
                    {isSearching ? 'Поиск...' : `Найдено ${searchResults.length} сообщений`}
                    <button className="clear-search-btn" onClick={closeSearch}>Очистить</button>
                  </div>
                )}
           

                {isSearchMode && searchResults.map(msg => (
                  <div key={msg.id} className="message-item">
                    <div className="message-avatar">
                      {msg.authorAvatar ? (
                        <img src={msg.authorAvatar} alt={msg.authorName} className="message-avatar-img" />
                      ) : (
                        <div className="message-avatar-text">
                          {msg.authorName?.charAt(0) || '?'}
                        </div>
                      )}
                    </div>
                    <div className="message-content">
                      <div className="message-header">
                        <span className="message-username">{msg.authorName}</span>
                        <span className="message-timestamp">
                          {new Date(msg.createdAt).toLocaleString('ru-RU')}
                          {msg.isEdited && <span className="edited-badge">(ред.)</span>}
                        </span>
                      </div>
                      <div className="message-text">
                        {msg.content && (
                          <MarkdownRenderer content={msg.content} />
                        )}
                        {!msg.isDeleted && msg.attachments?.map(att => (
                          <div key={att.id} className="message-attachment">
                            {att.mimeType?.startsWith('image/') ? (
                              <img src={att.url} alt={att.fileName} className="attachment-image" onClick={() => handleImageClick(att.url)}/>
                            ) : att.mimeType?.startsWith('video/') ? (
                              <video src={att.url} controls className="attachment-video" preload="metadata" />
                            ) : att.mimeType?.startsWith('audio/') ? (
                              <audio src={att.url} controls className="attachment-audio" preload="metadata" />
                            ) : att.mimeType === 'application/pdf' ? (
                              <div className="attachment-pdf">
                                <a href={att.url} target="_blank" rel="noopener noreferrer" className="attachment-link">
                                  📄 {att.fileName}
                                </a>
                                <button className="attachment-preview-btn" onClick={() => window.open(att.url, '_blank')}>
                                  👁️ Открыть PDF
                                </button>
                              </div>
                            ) : ['application/zip', 'application/x-rar-compressed', 'application/x-7z-compressed', 'application/x-tar', 'application/gzip'].includes(att.mimeType) ? (
                              <div className="attachment-archive">
                                <a href={att.url} target="_blank" rel="noopener noreferrer" className="attachment-link">
                                  📦 {att.fileName}
                                </a>
                                <span className="attachment-badge">🗜️ Архив</span>
                              </div>
                            ) : ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'].includes(att.mimeType) || 
                              att.mimeType?.startsWith('application/vnd.ms-') || att.mimeType?.startsWith('application/vnd.openxmlformats-') ? (
                              <div className="attachment-office">
                                <a href={att.url} target="_blank" rel="noopener noreferrer" className="attachment-link">
                                  📊 {att.fileName}
                                </a>
                                <span className="attachment-badge">📊 Office</span>
                              </div>
                            ) : (
                              <a href={att.url} target="_blank" rel="noopener noreferrer" className="attachment-link">
                                📎 {att.fileName}
                              </a>
                            )}
                          </div>
                        ))}
                        {msg.isDeleted && <span className="deleted-text">(сообщение удалено)</span>}
                      </div>
                    </div>
                  </div>
                ))}

                 {/* Триггер для подгрузки старых сообщений — вверху списка */}
                 {!isSearchMode && hasMoreMessages && (
                  <div ref={loadMoreRef} className="load-more-trigger-top">
                    {isLoadingMore && <div className="loading-spinner">Загрузка...</div>}
                  </div>
                )}
                
                {loading && <div className="loading">Загрузка сообщений...</div>}
                {!loading && messages.length === 0 && (
                  <div className="no-messages">Нет сообщений</div>
                )}
              {!isSearchMode &&  messages.map(msg => (
                <div 
                  key={msg.id} 
                  className="message-item" 
                  onContextMenu={(e) => handleMessageContextMenu(e, msg)}
                  onClick={(e) => handleMessageClick(e, msg)}
                >
                  <div className="message-avatar">
                    {msg.authorAvatar ? (
                      <img 
                        src={msg.authorAvatar} 
                        alt={msg.authorName || 'User'} 
                        className="message-avatar-img"
                      />
                    ) : (
                      <div className="message-avatar-text">
                        {msg.authorName?.charAt(0) || '?'}
                      </div>
                    )}
                  </div>
                  <div className="message-content">
                      <div className="message-header">
                        <span className="message-username">{msg.authorName}</span>
                        <span className="message-timestamp">
                          {formatMessageDate(msg.createdAt)}
                          {msg.isEdited && <span className="edited-badge">(ред.)</span>}
                        </span>
                        {/* Реакции */}
                        <MessageReactions 
                          message={msg}
                          currentUserId={user.id}
                          onUpdate={(updatedMessage) => {
                            setMessages(prev => prev.map(m => 
                              m.id === updatedMessage.id ? updatedMessage : m
                            ));
                          }}
                          />
                        {!isFavoriteChannel && (
                        <button
                          className={`save-star-btn ${savedMessageIds.includes(msg.id) ? 'saved' : ''}`}
                          onClick={() => {
                            if (savedMessageIds.includes(msg.id)) {
                              handleUnsaveMessage(msg.id);
                            } else {
                              handleSaveMessage(msg.id);
                            }
                          }}
                        >
                          {savedMessageIds.includes(msg.id) ? '⭐' : '☆'}
                        </button>
                        )}
                        <div className="message-read-status">
                          {msg.isReadByAllParticipants ? (
                            <span className="read-all" title="Прочитано всеми">✅</span>
                          ) : msg.readUsers?.length > 0 ? (
                            <span className="read-some" title={`Прочитано ${msg.readUsers?.length} участниками`}>
                              ✓ {msg.readUsers.length}
                            </span>
                          ) : null}
                        </div>

                        {msg.readUsers?.length > 0 && (
                          <div className="read-avatars">
                            {msg.readUsers.map(user => (
                              <div key={user.id} className="read-avatar-wrapper" title={user.name}>
                                {user.avatarUrl ? (
                                  <img 
                                    src={user.avatarUrl} 
                                    alt={user.name} 
                                    className="read-avatar-img"
                                  />
                                ) : (
                                  <div className="read-avatar-letter">
                                    {user.name?.charAt(0)?.toUpperCase() || '?'}
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        )}
                        {/* Кнопка ответа — появляется при наведении */}
                        <button 
                          className="reply-btn"
                          onClick={() => handleReplyClick(msg)}
                          title="Ответить на сообщение"
                        >
                          ↩️
                        </button>
                      </div>
                      
                      {/* Если это ответ — показываем цитату */}
                      {msg.replyTo && (
                      <div className="message-reply-to">
                        <div className="reply-to-header">
                          <div className="reply-to-avatar">
                            {msg.replyToAuthorAvatar ? (
                              <img src={msg.replyToAuthorAvatar} alt={msg.replyToAuthorName} className="reply-to-avatar-img" />
                            ) : (
                              <div className="reply-to-avatar-placeholder">
                                {msg.replyToAuthorName?.charAt(0)?.toUpperCase() || '?'}
                              </div>
                            )}
                          </div>

                          <div className="reply-to-info">
                            <span className="reply-to-author">
                              {msg.replyToAuthorName }:
                            </span>
                          </div>
                        </div>
                        
                        <div className="reply-to-content">
                          {/* Текст исходного сообщения с linkify */}
                          {msg.replyToContent && (
                            <div dangerouslySetInnerHTML={{ __html: linkify(msg.replyToContent).replace(/@([\p{L}\p{N}_]+)/gu, '<span class="mention">$1</span>') }} />
                          )}

                          {/* Вложения исходного сообщения */}
                          {msg.replyToAttachments?.map(att => (
                            <div key={att.id} className="message-attachment">
                              {att.mimeType?.startsWith('image/') ? (
                                <img 
                                  src={att.url} 
                                  alt={att.fileName} 
                                  className="attachment-image" 
                                  onClick={() => handleImageClick(att.url)}
                                />
                              ) : att.mimeType?.startsWith('video/') ? (
                                <video 
                                  src={att.url} 
                                  controls 
                                  className="attachment-video"
                                  preload="metadata"
                                />
                              ) : (
                                <a href={att.url} target="_blank" rel="noopener noreferrer" className="attachment-link">
                                  📎 {att.fileName}
                                </a>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
      

                      {/* Режим редактирования */}
                      {editingMessageId === msg.id ? (
                        <div className="message-edit-mode">
                          <input
                            type="text"
                            value={editMessageContent}
                            onChange={(e) => setEditMessageContent(e.target.value)}
                            className="edit-input"
                            autoFocus
                          />
                          <div className="edit-actions">
                            <button onClick={handleSaveEdit} className="edit-save-btn">Сохранить</button>
                            <button onClick={handleCancelEdit} className="edit-cancel-btn">Отмена</button>
                          </div>
                        </div>
                      ) : (
                      <div className="message-text">
                        {msg.content && 
                        isFullHtmlDocument(msg.content) ? (
                              <iframe
                                srcDoc={msg.content}
                                className="html-iframe"
                                sandbox="allow-scripts allow-modals"
                                title="HTML-вложение"
                              />
                            ) : (
                              <MarkdownRenderer content={msg.content} />
                        )}
                        {!msg.isDeleted && msg.attachments?.map(att => (
                          <div key={att.id} className="message-attachment">
                            {att.mimeType?.startsWith('image/') ? (
                              <img src={att.url} alt={att.fileName} className="attachment-image" onClick={() => handleImageClick(att.url)}/>
                            ) : att.mimeType?.startsWith('video/') ? (
                              <video 
                                src={att.url} 
                                controls 
                                className="attachment-video"
                                preload="metadata"
                              />
                            ): (
                              <a href={att.url} target="_blank" rel="noopener noreferrer" className="attachment-link">
                                📎 {att.fileName}
                              </a>
                            )}
                          </div>
                        ))}
                        {msg.isDeleted && <span className="deleted-text">(сообщение удалено)</span>}
                      </div>
                      )}
                    </div>
                    
                    
                    {/* Панель выбора реакций */}
                    
                </div>
                
              ))}
              {uploadingMessages.map(msg => (
                  <div key={msg.id} className="message-item uploading-message">
                      <div className="message-avatar">
                          {msg.authorAvatar ? <img src={msg.authorAvatar} /> : msg.authorName[0]}
                      </div>
                      <div className="message-content">
                          <div className="message-header">
                              <span className="message-username">{msg.authorName}</span>
                              <span className="message-timestamp">
                                  {new Date(msg.createdAt).toLocaleTimeString()}
                              </span>
                          </div>
                          <div className="message-text">
                              <div className="uploading-file-info">
                                  <span>📤 {msg.fileName}</span>
                                  <span className="file-size">
                                      {(msg.fileSize / 1024 / 1024).toFixed(1)} MB
                                  </span>
                              </div>
                              <div className="upload-progress-bar">
                                  <div 
                                      className="upload-progress-fill" 
                                      style={{ width: `${msg.progress}%` }}
                                  />
                                  <span className="upload-progress-text">{msg.progress}%</span>
                              </div>
                          </div>
                      </div>
                  </div>
              ))}
              

              <div ref={messagesEndRef} />
            </div>
            {/* Индикатор печатания */}
            {typingUser && (
                <div className="typing-indicator-wrapper">
                    {/* Плейсхолдер аватара, чтобы сдвинуть текст вправо как у сообщений */}
                    <div className="typing-avatar-placeholder"></div>
                    
                    <div className="typing-indicator-content">
                        <span className="typing-text">{typingUser} печатает</span>
                        <div className="typing-dots">
                            <span className="dot"></span>
                            <span className="dot"></span>
                            <span className="dot"></span>
                        </div>
                    </div>
                </div>
            )}
            {/* Input Area */}
            {canWrite && (
            <div className="message-input-area">
              {/* Цитата, если есть ответ */}
              {replyToMessage && (
                <div className="reply-preview">
                  <div className="reply-header">
                    <span className="reply-author">{replyToMessage.authorName}</span>
                    <button className="reply-close" onClick={() => setReplyToMessage(null)}>✕</button>
                  </div>
                  <div className="reply-content">
                    {replyToMessage.content?.substring(0, 100)}
                    {replyToMessage.content?.length > 100 && '...'}
                  </div>
                </div>
              )}
              <form onSubmit={handleSendMessage} className="message-input-form">
                <button 
                  type="button" 
                  className="message-input-btn"
                  onClick={() => fileInputRef.current?.click()}
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13" />
                  </svg>
                </button>
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={handleFileUpload}
                  style={{ display: 'none' }}
                  multiple
                />
                {showMentions && mentionSuggestions.length > 0 && (
                  <div className="mention-suggestions">
                    {mentionSuggestions.map(user => (
                      <div 
                        key={user.id} 
                        className="mention-suggestion-item"
                        onClick={() => handleMentionSelect(user)}
                      >
                        {user.avatarUrl ? (
                          <img src={user.avatarUrl} alt={user.username} className="mention-suggestion-avatar" />
                        ) : (
                          <div className="mention-suggestion-avatar-placeholder">
                            {user.username?.[0]?.toUpperCase() || '?'}
                          </div>
                        )}
                        <span className="mention-suggestion-name">@{user.username}</span>
                      </div>
                    ))}
                  </div>
                )}
                <input
                  type="text"
                  ref={messageInputRef}
                  value={inputMessage}
                  onChange={(e) => {{setInputMessage(e.target.value);handleInputChange(e);}}}
                  onKeyDown={handleTyping}
                  onPaste={handlePaste}
                  placeholder="Введите текст..."
                  className="message-input"
                />
                <button type="submit" className="message-send-btn">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5" />
                  </svg>
                </button>
              </form>
            </div>
            )}
          </>
        )}
        </>
      )}
      </div>
      {/* Модальное окно для изображений (добавьте в самый конец) */}
      {selectedImage && (
        <div className="image-modal" onClick={closeModal}>
          <div className="modal-content">
            <img src={selectedImage} alt="Увеличенное изображение" className="image-modal-img" />
            <button className="modal-close" onClick={closeModal}>✕</button>
          </div>
        </div>
      )}
      {/* Модальное окно создания сайта */}
      {isCreateSiteModalOpen && (
        <div className="modal-overlay" onClick={closeCreateSiteModal}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <h2>Создать новый сайт</h2>
            
            <div className="form-group">
              <label>Название</label>
              <input 
                type="text" 
                value={newSiteName} 
                onChange={e => setNewSiteName(e.target.value)}
                placeholder="Введите название сайта"
                className="modal-input"
              />
            </div>
            
            <div className="form-group">
              <label>Описание</label>
              <textarea 
                value={newSiteDescription} 
                onChange={e => setNewSiteDescription(e.target.value)}
                placeholder="Введите описание сайта"
                className="modal-textarea"
              />
            </div>
            
            <div className="form-group">
              <label>Иконка</label>
              <input 
                type="file" 
                accept="image/*" 
                onChange={handleSiteIconUpload}
                className="modal-file-input"
              />
              {newSiteIcon && (
                <div className="icon-preview">
                  <img src={newSiteIcon} alt="Иконка сайта" className="icon-preview-img" />
                </div>
              )}
            </div>
            
            <div className="form-group">
              <label>Участники</label>
              <div className="member-select">
                {allUsers.map(user => (
                  <label key={user.id} className="member-select-item">
                    <div className="member-select-avatar">
                      {user.avatarUrl ? (
                        <img src={user.avatarUrl} alt={user.username} className="member-select-avatar-img" />
                      ) : (
                        <div className="member-select-avatar-placeholder">
                          {user.username?.[0]?.toUpperCase() || '?'}
                        </div>
                      )}
                    </div>
                    <span className="member-select-name">{user.username || user.email}</span>
                    <input 
                      type="checkbox" 
                      className="member-select-checkbox"
                      checked={selectedMemberIds.includes(user.id)}
                      onChange={() => {
                        if (selectedMemberIds.includes(user.id)) {
                          setSelectedMemberIds(prev => prev.filter(id => id !== user.id));
                        } else {
                          setSelectedMemberIds(prev => [...prev, user.id]);
                        }
                      }}
                    />
                  </label>
                ))}
              </div>
            </div>
            
            <div className="modal-actions">
              <button 
                className="modal-btn cancel" 
                onClick={closeCreateSiteModal}
                disabled={isCreatingSite}
              >
                Отмена
              </button>
              <button 
                className="modal-btn create" 
                onClick={handleCreateSite}
                disabled={!newSiteName.trim() || isCreatingSite}
              >
                {isCreatingSite ? 'Создание...' : 'Создать'}
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* Контекстное меню */}
      {contextMenu  && isOwner && (
          <div 
              className="context-menu" 
              style={{ top: contextMenu.y, left: contextMenu.x }}
              onClick={handleCloseContextMenu}
          >
              <div className="context-menu-item" onClick={handleEditSite}>
                  ⚙️ Редактировать сайт
              </div>
              <div className="context-menu-divider"></div>
              <div className="context-menu-item delete" onClick={() => handleDeleteSite(contextMenu.site.id)}>
                  🗑️ Удалить сайт
              </div>
          </div>
      )}
      {/* Модальное окно редактирования сайта */}
        {editingSite && (
            <div className="modal-overlay" onClick={() => setEditingSite(null)}>
                <div className="modal-content" onClick={e => e.stopPropagation()}>
                    <h2>Редактировать сайт: {editingSite.name}</h2>
                    
                    <div className="form-group">
                        <label>Название</label>
                        <input 
                            type="text" 
                            value={editSiteName} 
                            onChange={e => setEditSiteName(e.target.value)}
                            className="modal-input"
                        />
                    </div>
                    
                    <div className="form-group">
                        <label>Описание</label>
                        <textarea 
                            value={editSiteDescription} 
                            onChange={e => setEditSiteDescription(e.target.value)}
                            className="modal-textarea"
                        />
                    </div>
                    
                    <div className="form-group">
                        <label>Иконка</label>
                        <input 
                            type="file" 
                            accept="image/*" 
                            onChange={handleEditSiteIconUpload}
                            className="modal-file-input"
                        />
                        {editSiteIcon && (
                            <div className="icon-preview">
                                <img src={editSiteIcon} alt="Иконка" className="icon-preview-img" />
                            </div>
                        )}
                    </div>
                    
                    <div className="form-group">
                    <label>Участники</label>
                    <div className="member-select">
                      {allUsers.map(member => (
                        <label key={member.id} className="member-select-item">
                          <div className="member-select-avatar">
                            {member.avatarUrl ? (
                              <img src={member.avatarUrl} alt={member.username} className="member-select-avatar-img" />
                            ) : (
                              <div className="member-select-avatar-placeholder">
                                {member.username?.[0]?.toUpperCase() || '?'}
                              </div>
                            )}
                          </div>
                          <span className="member-select-name">{member.username || member.email}</span>
                          <input 
                            type="checkbox" 
                            className="member-select-checkbox"
                            checked={selectedEditMembers.includes(member.id)}
                            onChange={() => {
                              if (selectedEditMembers.includes(member.id)) {
                                setSelectedEditMembers(prev => prev.filter(id => id !== member.id));
                              } else {
                                setSelectedEditMembers(prev => [...prev, member.id]);
                              }
                            }}
                          />
                        </label>
                      ))}
                    </div>
                  </div>
                    
                    <div className="modal-actions">
                        <button 
                            className="modal-btn delete" 
                            onClick={() => handleDeleteSite(editingSite.id)}
                        >
                            🗑️ Удалить сайт
                        </button>
                        <button 
                            className="modal-btn cancel" 
                            onClick={() => setEditingSite(null)}
                        >
                            Отмена
                        </button>
                        <button 
                            className="modal-btn save" 
                            onClick={handleUpdateSite}
                            disabled={!editSiteName.trim() || isUpdatingSite}
                        >
                            {isUpdatingSite ? 'Сохранение...' : 'Сохранить'}
                        </button>
                    </div>
                </div>
            </div>
        )}
        {/* Модальное окно для каналов */}
          {isChannelModalOpen && (
              <div className="modal-overlay" onClick={closeChannelModal}>
                  <div className="modal-content" onClick={e => e.stopPropagation()}>
                      <h2>{editingChannel ? 'Редактировать канал' : 'Создать канал'}</h2>
                      
                      <div className="form-group">
                          <label>Название канала</label>
                          <input 
                              type="text" 
                              value={channelName} 
                              onChange={e => setChannelName(e.target.value)}
                              placeholder="Введите название канала"
                              className="modal-input"
                          />
                      </div>
                      
                      <div className="form-group">
                          <label>Тема канала</label>
                          <input 
                              type="text" 
                              value={channelTopic} 
                              onChange={e => setChannelTopic(e.target.value)}
                              placeholder="Введите тему канала (необязательно)"
                              className="modal-input"
                          />
                      </div>
                      
                      <div className="form-group">
                          <label>Позиция</label>
                          <input 
                              type="number" 
                              value={channelPosition} 
                              onChange={e => setChannelPosition(parseInt(e.target.value) || 0)}
                              className="modal-input"
                              min="0"
                          />
                      </div>
                      
                      <div className="form-group">
                        <label>Тип канала</label>
                        <div className="select-wrapper">
                        <select className="modal-select"  value={channelType} onChange={e => setChannelType(e.target.value)}>
                          <option value="text">Обычный чат</option>
                          <option value="project">Доска задач</option>
                          <option value="collectionset">Набор коллекции</option>
                          <option value="collection">Коллекция</option>
                        </select>
                        </div>
                      </div>

                      {channelType === 'project' && (
                        <div className="form-group">
                          <label>Области (колонки)</label>
                          <div className="areas-container">
                            {areas.map((area, index) => (
                              <div key={index} className="area-chip">
                                <input
                                  type="text"
                                  value={area}
                                  onChange={(e) => {
                                    const newAreas = [...areas];
                                    newAreas[index] = e.target.value;
                                    setAreas(newAreas);
                                  }}
                                  className="area-chip-input"
                                  placeholder="Название области"
                                />
                                <button 
                                  className="area-chip-remove"
                                  onClick={() => setAreas(areas.filter((_, i) => i !== index))}
                                  type="button"
                                >
                                  ✕
                                </button>
                              </div>
                            ))}
                            
                            <button 
                              className="area-chip-add"
                              onClick={() => setAreas([...areas, 'Новая область'])}
                              type="button"
                            >
                              + Добавить область
                            </button>
                          </div>
                        </div>
                      )}
                      {channelType === 'collection' && (
                        <div className="form-group">
                          <label>Набор коллекций</label>
                          <select 
                            className="modal-select"
                            value={collectionSetId}
                            onChange={e => setCollectionSetId(e.target.value)}
                          >
                            <option value="">Выберите набор...</option>
                            {collectionSets.map(set => (
                              <option key={set.id} value={set.id}>
                                {set.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}
                      <div className="modal-actions">
                          <button 
                              className="modal-btn cancel" 
                              onClick={closeChannelModal}
                              disabled={isCreatingChannel}
                          >
                              Отмена
                          </button>
                          <button 
                              className="modal-btn create" 
                              onClick={handleChannelSubmit}
                              disabled={!channelName.trim() || isCreatingChannel}
                          >
                              {isCreatingChannel ? 'Сохранение...' : editingChannel ? 'Сохранить' : 'Создать'}
                          </button>
                      </div>
                  </div>
              </div>
          )}
          {/* Контекстное меню для каналов */}
          {channelContextMenu && isOwner && (
              <div 
                  className="context-menu" 
                  style={{ top: channelContextMenu.y, left: channelContextMenu.x }}
                  onClick={closeChannelContextMenu}
              >
                  <div className="context-menu-item" onClick={() => openEditChannelModal(channelContextMenu.channel)}>
                      ✏️ Редактировать канал
                  </div>
                  <div className="context-menu-divider"></div>
                  <div className="context-menu-item delete" onClick={() => handleDeleteChannel(channelContextMenu.channel.id)}>
                      🗑️ Удалить канал
                  </div>
              </div>
          )}
          {contextMenuEditMessage && (
            <div 
              className="context-menu"
              style={{ top: contextMenuEditMessage.y, left: contextMenuEditMessage.x }}
              onClick={closeMessageContextMenu}
            >
              <div className="context-menu-item" 
                onClick={(e) => {
                  e.stopPropagation();
                  handleEditMessage();
                }}
                >
                ✏️ Редактировать
              </div>
              <div className="context-menu-item delete" 
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteMessage();
              }}
              
              >
                🗑️ Удалить
              </div>
            </div>
          )}
    </div>
  );
};

export default ServerView;